<template>
  <!-- Header Section -->
  <div class="row wrapper border-bottom white-bg page-heading">
    <!-- Title on the left -->
    <div class="col-lg-8 align-self-center">
      <h2 class="mb-0">{{$t('navigations.fhir alert configuration')}}</h2>
    </div>
  </div>
  <div class="wrapper wrapper-content px-0">
    <div class="ibox mb-2">
      <!-- <div class="ibox-title style_2">
        <h5 class="mb-0"><i class="fa fa-filter me-2"></i>Select Form</h5>
        <div class="ibox-tools">
        </div>
      </div> -->
      <div class="ibox-content">
        <!-- Filter Section -->
            <!-- <div class="col-md-3">
              <label class="form-label">Study</label>
              <select class="form-select" v-model="selectedStudy">
                <option v-for="study in studies" :value="study.value" :key="study">{{ study.label }}</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label">Subject</label>
              <select class="form-select" v-model="selectedSubject">
                <option v-for="subject in subjects" :value="subject.value" :key="subject">{{ subject.label }}</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label">Visit</label>
              <select class="form-select" v-model="selectedVisit">
                <option v-for="visit in visits" :value="visit.value" :key="visit">{{ visit.label }}</option>
              </select>
            </div> -->
            <div class="row mb-2">
              <div class="col-5">
                  <label class="form-label" for="eproTemplates">{{$t('navigations.resource type')}}</label>
                  <select class="form-select" id="eproTemplates" v-model="selectedTemplate" @change.prevent="getFHIRResourceChange($event.target.value)">
                    <option selected disabled value="">{{ $t('navigations.select resource type') }}</option>
                    <option v-for="template in templateList" :value="template" :key="template">{{ template }}</option>
                  </select>
              </div>
              <div class="col-5">
                <label class="form-label" for="eproTemplates">{{$t('navigations.category')}}</label>
                <select class="form-select" id="eproTemplates" v-model="selectedCategory" @change.prevent="getFHIRCategoryChange()">
                  <option selected disabled value="">{{ $t('navigations.select category') }}</option>
                  <option v-for="item in selectedResourceTypeCategory" :value="item.display" :key="item.display">{{ item.display }}</option>
                </select>
                <p class="form-text mb-0">{{ $t('navigations.please select a resource type for corresponding category list') }}</p>
              </div>
            </div>
          <!-- <div class="my-3 d-flex justify-content-between align-items-center">
            <div>
              <span class="status-active">
                <i class="fa fa-check-circle me-1"></i>
                Active Study: {{ getStudyLabel(selectedStudy) }}
              </span>
            </div>
            <div>
              <button class="btn btn-sm btn-outline-primary me-2 py-0" @click="refreshData">
                Refresh
              </button>
              <button class="btn btn-sm btn-primary py-0" @click="applyFilters">
                Apply
              </button>
            </div>
          </div> -->

        <!-- Form Fields Section -->
         <div v-if="selectedCategory" class="d-flex justify-content-between align-items-center mb-4">
            <h4 class="mb-0">{{$t('navigations.configure alert for')}}: {{ selectedCategory }}</h4>
            <!-- <div class="d-flex">
                <button  class="btn btn-sm btn-outline-primary py-0 mr-2"
                @click="openViewAlertFormModal()">
                <i class="fa fa-eye me-1"></i> View Alert
              </button>   
              <button class="btn btn-sm btn-primary py-0" @click="openSetAlertForm()">
                <i class="fa fa-bell me-1"></i> Set Alerts for Form
              </button>
            </div> -->
           
          </div>
         <template v-if="showFieldsLoader ==true">
          <div class="text-center">
             <img
            src="../../assets/img/loading.gif"
            width="15"
            class=""
            alt="Waiting for login"
            />
            <div>
              {{ $t("navigations.please wait while the list is being loaded") }}
            </div>
          </div>         
         </template>
         <template v-else>
          <div v-if="selectedCategory" :class="{'max-h-400':selectedFormFields.length>4}" 
            id="formFieldsSection">            
            <div v-if="selectedCategory" id="formFieldsContainer">
              <div v-for="(field,index) in selectedFormFields" :key="index" class="card form-field-card px-3 py-1">
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <h4 class="mb-0">{{ field.display }}</h4>
                  <!-- <span v-if="alertsConfig[field.id]" class="badge alert-type-badge"
                    :class="'priority-' + alertsConfig[field.id].priority">
                    {{ alertsConfig[field.id].type }} Alert
                  </span> -->
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <small class="text-muted">{{ $t('navigations.field description')}} - {{ field.description }}
                    <span v-if="field.unit">({{ field.unit ? field.unit:'' }})</span>
                  </small>
                  <div>
                     <button v-if="hasAlert(field.display)" class="btn btn-sm btn-outline-primary ms-2 py-0"
                      @click="openViewAlertModal(field)">
                      <i class="fa fa-eye me-1"></i>{{ $t('navigations.view alert') }}
                    </button>   
                     <button class="btn btn-sm btn-primary py-0 ms-2 " @click="openSetAlertModal(field)">
                      <i class="fa fa-plus-circle me-1"></i>
                     {{ $t('navigations.alert') }}
                    </button>    
                                                   
                  </div>
                </div>
              </div>
            </div>
          </div>
         </template>
       

        <!-- Empty State -->
        <div class="text-center py-5" v-if="!templateObj">
          <div class="mb-3">
            <i class="fas fa-file-alt fa-3x text-muted"></i>
          </div>
          <h4 class="mb-3">Select a Form to Configure Alerts</h4>
          <p class="text-muted">Choose a form from the dropdown above to start configuring alert mechanisms</p>
        </div>
      </div>
    </div>

   
    <!-- <div class="modal fade" id="viewAlertModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">View Alert Configuration</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" v-if="viewedField && viewedAlert">
            <div class="mb-3">
              <h5>{{ viewedField.label }} Alert</h5>
              <span class="badge alert-type-badge" :class="'priority-' + viewedAlert.priority">
                {{ viewedAlert.type }} Alert
              </span>
            </div>
            
            <div v-if="viewedAlert.type === 'threshold'" class="mb-3">
              <h6>Threshold Condition</h6>
              <p>Alert when value is {{ viewedAlert.operator }} {{ viewedAlert.value }}</p>
            </div>
            
            <div class="mb-3">
              <h6>Threshold Time</h6>
              <p>{{ viewedAlert.thresholdTime }} hours</p>
            </div>
            
            <div class="mb-3">
              <h6>{{$t('navigations.alert message')}}</h6>
              <p>{{ viewedAlert.message }}</p>
            </div>
            
            <div class="mb-3">
              <h6>{{$t('navigations.notification method')}} :</h6>
              <ul>
                <li v-if="viewedAlert.notifications.email">Email</li>
                <li v-if="viewedAlert.notifications.sms">SMS</li>
                <li v-if="viewedAlert.notifications.inApp">In-App Notification</li>
              </ul>
            </div>
            
            <div class="mb-3">
              <h6>Recipients</h6>
              <p v-if="viewedAlert.recipients.email.length"><strong>Emails:</strong> {{ viewedAlert.recipients.email.join(', ') }}</p>
              <p v-if="viewedAlert.recipients.phone.length"><strong>Phones:</strong> {{ viewedAlert.recipients.phone.join(', ') }}</p>
            </div>
            
            <div class="mb-3">
              <h6>Roles Notified</h6>
              <p>
                <span v-if="viewedAlert.roles.physician">Physicians</span>
                <span v-if="viewedAlert.roles.physician && viewedAlert.roles.nurse">, </span>
                <span v-if="viewedAlert.roles.nurse">Nurses</span>
                <span v-if="(viewedAlert.roles.physician || viewedAlert.roles.nurse) && viewedAlert.roles.coordinator">, </span>
                <span v-if="viewedAlert.roles.coordinator">Coordinators</span>
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="editCurrentAlert">Edit Alert</button>
          </div>
        </div>
      </div>
    </div> -->

  </div>
   <!-- Add Alert Modal -->
  <customModal :containermd="true" v-if="alertModal == true" :bodymd="true"
    @closeModal="closeAlertModal(selectedObj)" :footerShow="true">
    <template #title>{{$t('navigations.configure field alert')}}&nbsp;&nbsp;<small>{{ currentField.label }}</small></template>
    <template #body>
        <form>
          <div class="row">
            <div class="col-12 col-md-6 mb-2">
              <label for="alertType" class="form-label">{{$t('navigations.alert type')}}<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
              <select id="alertType" class="form-select" v-model="newAlert.alertType" required>
                <option value="">{{ $t('navigations.select alert type') }}</option>
                <option v-for="option in alertCategories" :key="option.id" :value="option">{{ option }}</option>
              </select>
              <span v-if="alertError[0] == true" class="errormsg ml-0"> {{ $t("navigations.please choose a value") }}</span>
            </div>
            <div class="col-12 col-md-6 mb-2">
              <label for="priority" class="form-label">{{ $t('navigations.priority') }}<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
              <select id="priority" class="form-select" v-model="newAlert.priority" required>
                <option value="">{{$t('navigations.select priority')}}</option>
                <option value="High">{{$t('navigations.high')}}</option>
               <option value="Moderate">{{$t('navigations.moderate')}}</option>
                <option value="Critical">{{$t('navigations.critical')}}</option>
              </select>
              <span v-if="alertError[1] == true" class="errormsg ml-0"> {{ $t("navigations.please choose a value") }}</span>
            </div>
            <div class="col-12 col-md-6 mb-2">
              <label for="priority" class="form-label">{{ $t('navigations.alert rule') }}<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
              <select id="priority" class="form-select" v-model="newAlert.alertRule" required>
                <option value="">Select rule...</option>
                <option value="Condition">{{ $t('navigations.condition') }}</option>
                <option value="Missing">{{ $t('navigations.missing') }}</option>
              </select>
              <span v-if="alertError[2] == true" class="errormsg ml-0"> {{ $t("navigations.please choose a value") }}</span>
            </div>
            <template v-if="newAlert.alertRule=='Condition'">
             <div class="col-12 d-flex justify-content-between">
              <label class="px-0">{{ $t("navigations.conditional rules") }}<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
              <div class="position-relative align-self-center" aria-label="add row" tabindex="0">
                <img width="20" class="cursor-pointer" src="../../assets/img/create.png" alt="Create user" @click="addRow('get')" />
                <div class="tool-tip">{{ $t("navigations.add row") }}</div>
              </div>
            </div>
            
            <div v-for="(filter, index) in conditionalRules" :key="index" class="row px-0 mx-0 mb-2">
              <div class="col-5 mb-2">
              <label for="alertCondition" class="form-label">{{ $t('navigations.condition') }}<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
              <select id="alertCondition" class="form-select" v-model="filter.condition">
                <option
                  v-for="(conditions,index) in conditionsArray"
                  :key="index"
                  :value="conditions.value"
                >
                  {{ conditions.label }}
                </option>
              </select>
              </div>
              <div class="col-5 mb-2">
                <label class="form-label">{{ $t('navigations.value') }}<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
                  <template v-if="currentField.type=='year'">                        
                    <input type="number" @keydown="preventNonNumericKeys"   v-model="filter.value[0]"  class="form-control" id="fieldValue" name="year" min="1000" max="2100" step="1">
                  </template>
                  <template v-if="currentField.type=='date'">  
                      <input type="date" v-model="filter.value[0]" id="fieldValue" class="form-control">                                    
                  </template>
                  <template v-if="currentField.type=='radio' || currentField.type=='dropdown'">  
                      <select    v-model="filter.value[0]" id="fieldValue"  class="form-select"> 
                          <option
                            v-for="option in radiooptionsarray"
                            :value="option.codevalue"
                            :key="option.optionname"
                          >
                            {{ option.optionname }}
                          </option>            
                      </select>      
                  </template>
                  <template v-if="currentField.type!='date' && currentField.type!='year' && currentField.type!='radio' && currentField.type!='dropdown'  && currentField.type!='checkbox'">
                    <input type="text" v-model="filter.value[0]" id="fieldValue" class="form-control">
                  </template>
              </div>
              <div class="col-2 pl-0 mb-2 align-self-end">
                <button class="btn-circle position-relative" type="button" @click.prevent="deleteFilter(index)">
                  <i class="fa fa-minus"></i>
                  <div class="tool-tip">{{ $t("navigations.delete") }}</div>
                </button>
              </div>
            </div>
            <div v-if="alertError[7]==true" class="errormsg ml-0">
              {{ $t("navigations.please fill all condition and value fields correctly") }}
            </div>
            </template>
         
            <!-- <div class="col-md-6">
              <label class="form-label">Threshold Time (for data upload)<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
              <div class="input-group">
                <input type="number" class="form-control threshold-input" v-model="alertType" min="1">
                <span class="input-group-text">hours</span>
              </div>
              <p class="form-text mb-0">Time limit for data upload during a visit</div>
            </div> -->
          <div class="col-12 mb-2">
            <label for="alertMessage" class="form-label">{{$t('navigations.alert message')}}<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>            
            <textarea id="alertMessage" class="form-control" v-model="newAlert.alertMessage" rows="3" required></textarea>
            <p class="form-text mb-0">{{$t('navigations.custom message displayed when alert triggers')}}</p>
            <span v-if="alertError[3] == true" class="errormsg ml-0"> {{ $t("navigations.please enter a value") }}</span>
          </div>

          <div class="mb-3">
            <label class="form-label mr-2" for="notificationMethod">{{$t('navigations.notification method')}}<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
             <Multiselect
                   id="notificationMethod" 
                   @clear="clearNotification()"
                    v-model="multiNotificationSelect"
                    mode="multiple"
                    valueProp="value"
                    placeholder="Select notification"
                    label="label"
                    :options="notificationList"
                    :hideSelected="false"
                    :closeOnSelect="false"
                    :searchable="true"
                    trackBy="label"
                    class="multiselect-theme"
                  >
                    <template v-slot:option="{ option }">
                      {{ option.label }}
                    </template>
                  </Multiselect>
              <span v-if="alertError[4] == true" class="errormsg ml-0"> {{ $t("navigations.please choose a value") }}</span>
          </div>
          <div class="col-12 col-md-6 mb-2">
              <label for="roleList" class="form-label">{{ $t("navigations.role") }} <span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
              <Multiselect
                id="roleList" 
                @close="onSelectClosed()"
                @clear="onClear()"
                v-model="multiRoleSelectList"
                mode="multiple"
                valueProp="roleID"
                placeholder="Select roles"
                label="roleName"
                :options="roleList"
                :hideSelected="false"
                :closeOnSelect="false"
                :searchable="true"
                trackBy="roleName"
                class="multiselect-theme"
              >
                <template v-slot:option="{ option }">
                  {{ option.roleName }}
                </template>
              </Multiselect>
              <span v-if="alertError[5] == true" class="errormsg ml-0"> {{ $t("navigations.please choose a value") }}</span>
              <!-- <span class="errorClass" v-if="errors[3]">{{ $t("navigations.please select role") }}</span> -->
            </div>
            <div class="col-12 col-md-6 mb-2">
              <label for="recipients" class="form-label">{{ $t('navigations.email recipients') }}<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label> 
              <Multiselect
                @clear="onRecipientClear()"
              id="recipients"
              valueProp="email"
              mode="multiple"
              placeholder="Select"
              :options="userList"
              :hideSelected="false"
              :closeOnSelect="false"
              class="multiselect-theme"
              size="30"
              v-model="newAlert.notificationEmail"
            > <template v-slot:option="{ option }">
                <span v-if="option">
                {{ option.email }}
              </span>
              </template>
            </Multiselect>
             <p class="form-text mb-0">{{ $t('navigations.please select a role to list users') }}</p>
             <span v-if="alertError[6] == true" class="errormsg ml-0"> {{ $t("navigations.please choose a value") }}</span>
            </div>
          </div>
        </form>
    </template>
    <template #footer>
      <div class="d-flex justify-content-end">
        <button @click.prevent="clearData()" type="button" class="btn btn-sm btn-outline-secondary mr-2 py-0">{{$t('navigations.clear')}}</button>
        <button type="button" class="btn btn-primary btn-sm py-0" @click="saveAlert">{{$t('navigations.save alert')}}</button>
      </div>

    </template>
  </customModal>
  <!-- View Alert Modal -->
  <customModal :containermd="true" :bodymd="getAlertValue && getAlertValue.length!=0 ? true:false" v-if="viewAlert == true" :positionRelative="true"
    @closeModal="closeViewAlertModal()">
    <template #title>{{$t('navigations.view alert')}} - <small>{{ currentField.label }}</small></template>
    <template #body>
        <div class="text-center" v-if="viewAlertLoading==true">
            <img
          src="../../assets/img/loading.gif"
          width="15"
          class=""
          alt="Waiting for login"
          />
          <div>
            {{ $t("navigations.please wait while the list is being loaded") }}
          </div>
        </div>       
        <template v-else>
          <template v-if="getAlertValue && getAlertValue.length!=0">
            <form v-for="(form,index) in getAlertValue" :key="form.id">
              <div class="row">
                <div class="col-12 col-md-6 mb-2" :class="{'mt-2':index>=1}">
                  <label for="alertType" class="form-label">{{$t('navigations.alert type')}}<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
                  <select id="alertType" class="form-select" v-model="form.alertType" required>
                    <option value="">{{ $t('navigations.select alert type') }}</option>
                    <option v-for="option in alertCategories" :key="option.id" :value="option">{{ option }}</option>
                  </select>
                  <span class="errormsg ml-0" v-if="alertError[index]?.alertType">{{ $t("navigations.please choose a value") }}</span>
                </div>
                <div class="col-12 col-md-6 mb-2" :class="{'mt-2':index>=1}">
                  <label for="priority" class="form-label">{{ $t('navigations.priority') }}<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
                  <select id="priority" class="form-select" v-model="form.priority" required>
                    <option value="">{{$t('navigations.select priority')}}</option>
                    <option value="High">{{$t('navigations.high')}}</option>
                   <option value="Moderate">{{$t('navigations.moderate')}}</option>
                    <option value="Critical">{{$t('navigations.critical')}}</option>
                  </select>
                  <span class="errormsg ml-0" v-if="alertError[index]?.priority">{{ $t("navigations.please choose a value") }}</span>
                </div>
                <div class="col-12 col-md-6 mb-2">
                  <label for="priority" class="form-label">{{ $t('navigations.alert rule') }}<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
                  <select id="priority" class="form-select" v-model="form.alertRule" required>
                    <option value="">Select rule...</option>
                    <option value="Condition">{{ $t('navigations.condition') }}</option>
                    <option value="Missing">{{ $t('navigations.missing') }}</option>
                  </select>
                  <span class="errormsg ml-0" v-if="alertError[index]?.alertRule">{{ $t("navigations.please choose a value") }}</span>
                </div>
                <div class="col-12 d-flex justify-content-between" v-if="form.alertRule=='Condition'">
                  <label class="px-0">{{ $t("navigations.conditional rules") }}<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
                  <div class="position-relative align-self-center" aria-label="add row" tabindex="0">
                    <img width="20" class="cursor-pointer" src="../../assets/img/create.png" alt="Create user" @click="addRow('view',index)" />
                    <div class="tool-tip">{{ $t("navigations.add row") }}</div>
                  </div>
                </div>
                <template v-if="form.alertRule=='Condition' && conditionalRules && conditionalRules[index]">
                   <div v-for="(filter, index) in conditionalRules[index]" :key="index" class="row px-0 mx-0 mb-2">
                    <div class="col-5 mb-2">
                    <label for="alertCondition" class="form-label">{{ $t('navigations.condition') }}<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
                    <select id="alertCondition" class="form-select" v-model="filter.condition">
                      <option
                        v-for="(conditions,index) in conditionsArray"
                        :key="index"
                        :value="conditions.value"
                      >
                        {{ conditions.label }}
                      </option>
                    </select>
                    </div>
                    <div class="col-5 mb-2">
                      <label class="form-label">{{ $t('navigations.value') }}<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
                         <template v-if="currentField.type=='year'">                        
                    <input type="number" @keydown="preventNonNumericKeys"   v-model="filter.value[0]"  class="form-control" id="fieldValue" name="year" min="1000" max="2100" step="1">
                  </template>
                  <template v-if="currentField.type=='date'">  
                      <input type="date" v-model="filter.value[0]" id="fieldValue" class="form-control">                                    
                  </template>
                  <template v-if="currentField.type=='radio' || currentField.type=='dropdown'">  
                      <select    v-model="filter.value[0]" id="fieldValue"  class="form-select"> 
                          <option
                            v-for="option in radiooptionsarray"
                            :value="option.codevalue"
                            :key="option.optionname"
                          >
                            {{ option.optionname }}
                          </option>            
                      </select>      
                  </template>
                  <template v-if="currentField.type!='date' && currentField.type!='year' && currentField.type!='radio' && currentField.type!='dropdown'  && currentField.type!='checkbox'">
                    <input type="text" v-model="filter.value[0]" id="fieldValue" class="form-control">
                  </template>
                    </div>
                    <div class="col-2 pl-0 my-1 align-self-end">
                      <button class="btn-circle position-relative" type="button" @click.prevent="deleteFilter(index)">
                        <i class="fa fa-minus"></i>
                        <div class="tool-tip">{{ $t("navigations.delete") }}</div>
                      </button>
                    </div>
                  </div>
                  <span class="errormsg ml-0" v-if="alertError[index]?.conditionals">{{ $t("navigations.please fill all condition and value fields correctly") }}</span>
                </template>
                <!-- <div class="col-md-6">
                  <label class="form-label">Threshold Time (for data upload)<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
                  <div class="input-group">
                    <input type="number" class="form-control threshold-input" v-model="alertType" min="1">
                    <span class="input-group-text">hours</span>
                  </div>
                  <p class="form-text mb-0">Time limit for data upload during a visit</div>
                </div> --> 
              <div class="col-12">
                <label for="alertMessage" class="form-label">{{$t('navigations.alert message')}}<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
                <p class="form-text mb-0">{{$t('navigations.custom message displayed when alert triggers')}}</p>
                <textarea id="alertMessage" class="form-control" v-model="form.alertMessage" rows="3" required></textarea>
                <span class="errormsg ml-0" v-if="alertError[index]?.alertMessage">{{ $t("navigations.please enter a value") }}</span>
              </div>

              <div class="mb-3">
                <label class="form-label mr-3" for="notificationMethod">{{$t('navigations.notification method')}}<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
               <Multiselect
                   id="notificationMethod" 
                    @clear="clearNotification(index)"
                    v-model="multiNotificationSelect[index]"
                    mode="multiple"
                    valueProp="value"
                    placeholder="Select notification"
                    label="label"
                    :options="notificationList"
                    :hideSelected="false"
                    :closeOnSelect="false"
                    :searchable="true"
                    trackBy="label"
                    class="multiselect-theme"
                  >
                    <template v-slot:option="{ option }">
                      {{ option.label }}
                    </template>
                  </Multiselect>
                  <span class="errormsg ml-0" v-if="alertError[index]?.notifications">{{ $t("navigations.please choose a value") }}</span>
              </div>
               <div class="col-12 col-md-6 mb-2">
                 <label for="roleList" class="form-label">{{ $t("navigations.role") }} <span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
                  <Multiselect
                   id="roleList" 
                   @close="getAlertSelectClosed(index)"
                    @clear="getAlertClear(index)"
                    v-model="multiRoleSelectList[index]"
                    mode="multiple"
                    valueProp="roleID"
                    placeholder="Select roles"
                    label="roleName"
                    :options="roleList"
                    :hideSelected="false"
                    :closeOnSelect="false"
                    :searchable="true"
                    trackBy="roleName"
                    class="multiselect-theme"
                  >
                    <template v-slot:option="{ option }">
                      {{ option.roleName }}
                    </template>
                  </Multiselect>
               <span class="errormsg ml-0" v-if="alertError[index]?.roles">{{ $t("navigations.please choose a value") }}</span>
                </div>
                <div class="col-12 col-md-6 mb-2">
                  <label for="recipients" class="form-label">{{ $t('navigations.email recipients') }}<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>                 
                  <Multiselect
                  id="recipients"
                  valueProp="email"
                  mode="multiple"
                  placeholder="Select"
                  :options="userList[index]"
                  :hideSelected="false"
                  :closeOnSelect="false"
                  class="multiselect-theme"
                  size="30"
                  v-model="form.notificationEmail"
                > <template v-slot:option="{ option }">
                    <span v-if="option">
                    {{ option.email }}
                  </span>
                  </template>
                </Multiselect>
                 <p class="form-text mb-0">{{ $t('navigations.please select a role to list users') }}</p>
                 <span class="errormsg ml-0" v-if="alertError[index]?.emails">{{ $t("navigations.please choose a value") }}</span>
                </div>
              </div>
        <!-- <div class="mb-3">
          <label class="form-label">Notify Roles<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
          <div class="row">
            <div class="col-md-4">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="modalForm.roles.physician">
                <label class="form-check-label">Physicians<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="modalForm.roles.nurse">
                <label class="form-check-label">Nurses<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="modalForm.roles.coordinator">
                <label class="form-check-label">Coordinators<span class="validation-block"><sup><i class="fa fa-asterisk"></i></sup></span></label>
              </div>
            </div>
          </div>
        </div> -->
            <div class="d-flex justify-content-end pb-3">
              <button type="button" @click.prevent="clearAlertArray(index)" class="btn btn-sm btn-outline-secondary mr-2 py-0">{{$t('navigations.clear')}}</button>
               <button type="button" @click.prevent="deleteAlertArray(index)" class="btn btn-sm btn-outline-danger mr-2 py-0">{{$t('navigations.delete')}}</button>
              <button type="button" class="btn btn-primary btn-sm py-0" @click="updateAlert(index,form.id)">{{$t('navigations.save alert')}}</button>
            </div>
            <div class="repeat-border-bottom" v-if="index!=getAlertValue.length-1"></div>
            </form>
          
          </template>
          <template v-else>
            <h4 class="text-center">{{ $t('navigations.no alerts found') }}</h4>
          </template>
        </template>
      
    </template>
  </customModal>
</template>

<script src="./setfhiralert.js"></script>

<style scoped>
.validation-block{
  font-size: 10px;
  padding-inline: 2px;
  color:hsl(0, 100%, 50%);
}
.multiselect-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
}
.repeat-border-bottom {
  border-bottom: 1px dashed hsl(237, 42%, 40%);
}
.max-h-400{
  max-height:400px;
  overflow-y: scroll;
}
.form-field-card {
  border-left: 4px solid #0d6efd;
  margin-bottom: .5rem;
}

.alert-type-badge {
  font-size: 0.7rem;
  font-weight: 300;
  padding: 0.2em 0.65em;
}

.priority-high {
  background-color: #dc3545;
}

.priority-medium {
  background-color: #fd7e14;
}

.priority-low {
  background-color: #ffc107;
}

.threshold-input {
  max-width: 100px;
}

.modal-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.filter-row {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
}

.status-active {
  color: #198754;
  font-weight: 500;
}

.ibox-content {
  border-radius: 0% !important;
}
.input-group-text{
  font-size: .8rem;
  line-height: 1.0;
}
</style>